<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted() {
    const culturaCounter = document.createElement('script');
    culturaCounter.setAttribute('src', 'https://culturaltracking.ru/static/js/spxl.js?pixelId=6067');
    culturaCounter.setAttribute('data-pixel-id', '6067');
    document.head.appendChild(culturaCounter);
  },
};
</script>
